import Projection from "ol/proj/Projection";
export const getPixelProjection = () => new Projection({
    code: "pixel",
    units: "pixels",
    extent: [-100000, -100000, 100000, 100000]
});
